.crumbs {
	display: flex;
	align-items: center;
	list-style: none;
	margin: 0;
	padding: 0;
}

.crumb {
	display: flex;
	align-items: center;

	& :is(a, [role='link']) {
		font: var(--lp-text-heading-1-medium);
	}

	& [role='link'][data-current] {
		font: var(--lp-text-heading-1-semibold);
	}
}

.separator {
	fill: var(--lp-color-fill-ui-secondary);
	height: var(--lp-size-24);
	width: var(--lp-size-24);
}
